import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  container: {
    position: "relative",
    minHeight: "calc(100vh - 300px)",
    paddingBottom: "40px",
  },
  containerView: {
    position: "relative",
    paddingBottom: 20,
  },
  title: {
    fontSize: "20px",
    fontFamily: "Manrope",
    color: "#465869",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "10px",
  },
  grid: {
    padding: "20px 0",
  },
  button: {
    color: "#FFFFFF",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "15px",
    height: "40px",
    borderRadius: "8px",
    padding: "14px",
    whiteSpace: "nowrap",
    "&.fullWidth": {
      width: "100%",
    },
  },
  iconButton: {
    marginRight: "5px",
  },
  buttons: {
    position: "absolute",
    bottom: 0,
    right: 0,
  },
}));

export default styles;
